import { JST_PRODUCT_LIST } from './jstErpFixtureData'

/** 聚水潭 ERP 第一章商品列表，统一复用练习数据源。 */
export function getGoodsList() {
  return JST_PRODUCT_LIST.map(item => ({ ...item }))
}



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/jstErpGoodsData.js